import React, { FC } from 'react';
import { Helmet } from 'react-helmet';

import { IconAlert } from '@ch/common/components/icon';
import { Heading } from '@ch/common/components/heading';
import { Text } from '@ch/common/components/text';
import { ErrorComponentWrapStyled, ErrorComponentStyled } from './error.styled';

const ErrorComponent: FC<{
  name: string;
  title: string;
  text?: string;
}> = ({ title, name, text }) => {
  return (
    <>
      <Helmet>
        <title>{name}</title>
      </Helmet>
      <ErrorComponentWrapStyled>
        <ErrorComponentStyled>
          <IconAlert $size={49} />
          <Heading as="h1" $align="center" $m={[15, 0]}>
            {name}
          </Heading>
          <Heading as="h2" $align="center" $mt={15}>
            {title}
          </Heading>
          <Text $size="sm">{text}</Text>
        </ErrorComponentStyled>
      </ErrorComponentWrapStyled>
    </>
  );
};

export default ErrorComponent;
